import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const providerKlass: Record<string, string> = {
  'Notifications::Providers::WebProvider': 'Web',
  'Notifications::Providers::EmailProvider': 'Email',
}

export const providerKlassOptions = strategyToOptions(providerKlass);
